var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: " con-btn" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb-layout" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "/" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("售后下单")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.servcOrder }
        },
        [
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [
              _c("span", { staticClass: "color-laber" }),
              _vm._v("卖家信息")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("公司名称")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.sellerName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("联系电话")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.sellerContactTel))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("所在地址")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.sellerRegionName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [
              _c("span", { staticClass: "color-laber" }),
              _vm._v("买家信息")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("零售商名称")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.buyerName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("零售商机构")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.buyerShopName))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("机构联系方式")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.buyerShopContactTel))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("零售商机构地址")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _vm._v(_vm._s(_vm.servcOrder.buyerShopAddr))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [
              _c("span", { staticClass: "color-laber" }),
              _vm._v("服务项信息")
            ])
          ]),
          _vm._v(" "),
          _vm.servcOrder.servcOrderItem != null
            ? _c("div", [
                _c("div", { staticClass: "form-single mt20 mb20" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("服务项")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "pos-rel" }, [
                      _vm._v(_vm._s(_vm.servcOrder.servcOrderItem.title))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single mt20 mb20" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("上次完成时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "pos-rel" }, [
                      _vm._v(_vm._s(_vm.servcOrder.servcOrderItem.finishTime))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single mt20 mb20" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("质保期")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "pos-rel" }, [
                      _vm._v(_vm._s(_vm.servcOrder.servcOrderItem.wrntPeriod))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-single mt20 mb20" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("质保到期时间")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "pos-rel" }, [
                      _vm._v(_vm._s(_vm.servcOrder.servcOrderItem.wrntDueTime))
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [
              _c("span", { staticClass: "color-laber" }),
              _vm._v("预约上门时间")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("预约上门时间")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c(
                "div",
                { staticClass: "pos-rel" },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetime",
                      placeholder: "选择日期",
                      format: "yyyy-MM-dd HH:mm"
                    },
                    model: {
                      value: _vm.planTime,
                      callback: function($$v) {
                        _vm.planTime = $$v
                      },
                      expression: "planTime"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [
              _c("span", { staticClass: "color-laber" }),
              _vm._v("附言")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-single mt20 mb20" }, [
            _c("div", { staticClass: "title" }, [_vm._v("附言")]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "pos-rel" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.servcOrder.postscript,
                      expression: "servcOrder.postscript"
                    }
                  ],
                  staticClass: "width-2x",
                  attrs: { placeholder: "请输入..." },
                  domProps: { value: _vm.servcOrder.postscript },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.servcOrder,
                        "postscript",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-toolbar", on: { click: _vm.submitClick } },
        [
          _c("button", { staticClass: "swb-btn swb-btn-small" }, [
            _vm._v("提交")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e68ce560", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e68ce560","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/servcOrder/AfterSaleOrderCreate.vue
// module id = 1964
// module chunks = 1